import React, { useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { useAITTheme, type AITTheme } from '@this/shared/ui/theme';

const headerHeight = '50px';

const AdminHeader = () => {
  const { theme } = useAITTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);

  return (
    <header className="noprint" style={styles.theHeader}>
      <div style={styles.headerIn}>
        <h1>
          {/* logoPath はサービスごとに異なり、theme.tokens に代わる値がないため deprecated な Themes の値を使う */}
          <RouterLink to="/admin" style={{ ...styles.logo, backgroundImage: `url('${theme.logoPath}')` }} />
        </h1>
        <div style={styles.linkArea}>
          <a id="password" href="/admin/edit" className="admin-header-button" style={styles.button}>
            パスワードの変更
          </a>
          <a id="logout" href="/admins/sign_out" className="admin-header-button" style={styles.button}>
            ログアウト
          </a>
        </div>
      </div>
    </header>
  );
};

const getStyles = (theme: AITTheme) => ({
  theHeader: {
    width: '100%',
    height: headerHeight
  },
  headerIn: {
    display: 'flex' as const,
    alignItems: 'center' as const,
    background: theme.tokens.colors.background.tertiary,
    borderBottom: '1px solid var(--link-color)',
    height: headerHeight
  },
  logo: {
    display: 'block' as const,
    width: 120,
    height: 21,
    marginLeft: 10,
    backgroundRepeat: 'no-repeat' as const,
    backgroundSize: 'contain' as const
  },
  linkArea: {
    display: 'flex' as const,
    marginLeft: 'auto'
  },
  button: {
    display: 'block' as const,
    marginRight: 15
  }
});

export default AdminHeader;
